var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.slug)?_c('span',{staticClass:"custom-reason"},[(_vm.$te(("shared.reasons." + _vm.slug)))?[_vm._v(_vm._s(_vm.$t(("shared.reasons." + _vm.slug))))]:[_vm._v(_vm._s(_vm.parseReason))]],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }